import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';

import moment from 'moment';
import api from '../../../../../_core/api';
import { handleErrors } from '../../../../../_core/services/toast';
import { LoadingWrapper } from './styles';
import { Table } from '../../../../../_core/_components';
import { BillingInfo } from '../../types';

type Props = {
  customerPriorizationData: BillingInfo;
};

export type HistoricoItem = {
  negotiationAgreement: {
    id: number;
    agreementDate: string;
    contactDate: string;
    negotiationType: {
      id: number;
      description: string;
      creationDate: string;
      active: true;
    };
    observation: string;
    usuarioInclusao: string;
    dataInclusao: Date;
  };
  slipNumber: number[];
};

const HistoricoNegociacao: React.FC<Props> = ({ customerPriorizationData }) => {
  const [loading, setLoading] = useState(false);
  const [listaHistorico, setListaHistorico] = useState<HistoricoItem[]>([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      const { data } = await api.get<HistoricoItem[]>(
        `/api/allos/v1/prioritization/agreement-negotiation-slip/history/${customerPriorizationData.clientId}`,
      );
      setListaHistorico(data);
    } catch (e) {
      handleErrors(e);
    }
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <LoadingWrapper>
          <CircularProgress />
        </LoadingWrapper>
      ) : (
        <Table
          columns={[
            { key: 'boletos', label: 'Boleto' },
            { key: 'dataContato', label: 'Data Contato' },
            { key: 'dataAcordo', label: 'Data Acordo' },
            { key: 'descricao', label: 'Status da Negociação' },
            { key: 'usuario', label: 'Usuário' },
            { key: 'observacao', label: 'Observação' },
          ]}
          data={listaHistorico.map(row => ({
            ...row,
            boletos: row.slipNumber?.join(', '),
            dataContato: moment(row.negotiationAgreement.contactDate).format('DD/MM/YYYY'),
            dataAcordo: moment(row.negotiationAgreement.agreementDate).format('DD/MM/YYYY'),
            descricao: row.negotiationAgreement.negotiationType?.description,
            usuario: row.negotiationAgreement.usuarioInclusao,
            observacao: row.negotiationAgreement.observation,
          }))}
        />
      )}
    </>
  );
};

export default HistoricoNegociacao;
